import type { Dashboard } from "~/types/dashboard";
import type { Profile } from "~/types/profile";

export function useDashboard() {
  const dashboardData: Ref<Dashboard> = useState<Dashboard>("dashboard");
  const adminView = useState<boolean>("adminView", () => {
    return false;
  });

  const {
    public: { inpCookieDomain },
  } = useRuntimeConfig();

  const jwt = useCookie("jwt", {
    domain: <string>inpCookieDomain,
  });

  /**
   * Carica i dati della dashboard
   */
  const loadDashboard = async (
    user_id: number | null = null,
  ): Promise<Dashboard> => {
    const user = useState<Profile>("profile");

    const uid = user_id || user.value.id;
    const r: any = await $fetch(`/api/user/dashboard`, {
      method: "POST",
      responseType: "json",
      credentials: "include",
      body: {
        t: Date.now(),
        jwt: jwt.value,
        id: uid,
      },
    });
    if (r.success) {
      dashboardData.value = r.object;
      if (user_id) {
        adminView.value = true;
      }
      return r.object;
    } else throw new Error(r.message);
  };

  return {
    loadDashboard,
    dashboardData,
  };
}
